import { StoreGroup, Store, StoreGroupStatus } from '../types/storeGroup';

// 模拟门店组数据
export const mockStoreGroups: StoreGroup[] = [
  {
    id: 'sg-001',
    code: 'SG001',
    name: 'East China Store Group',
    shopCodes: ['ST001', 'ST002', 'ST003', 'ST004', 'ST005'],
    displayGroupCode: 'DG001',
    displayGroupName: 'Beverage Display Group',
    creatorName: 'admin',
    gmtCreate: 1686370200000,
    typicalStoreCode: 'ST001',
    status: 'ENABLE',
    lastExportTime: 1686811200000,
    lastImportTime: 1686818400000,
    remark: 'Store group for East China region, covering stores in Shanghai, Jiangsu, Zhejiang and other areas',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-16 11:20:00',
    commercial_approver_account: 'commercial_director',
    commercial_approver_name: 'Zhang Wei',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-17 09:45:00',
    planogram_approver_account: 'planogram_director',
    planogram_approver_name: 'Li Ming',
  },
  {
    id: 'sg-002',
    code: 'SG002',
    name: 'North China Store Group',
    shopCodes: ['ST006', 'ST007', 'ST008', 'ST009'],
    displayGroupCode: 'DG002',
    displayGroupName: 'Snack Display Group',
    creatorName: 'admin',
    gmtCreate: 1686543900000,
    typicalStoreCode: 'ST006',
    status: 'ENABLE',
    lastExportTime: 1686897300000,
    lastImportTime: 1686904500000,
    remark: 'Store group for North China region, covering stores in Beijing, Tianjin, Hebei and other areas',
    commercial_approver_status: 'PENDING',
    commercial_approver_time: undefined,
    commercial_approver_account: undefined,
    commercial_approver_name: undefined,
    planogram_approver_status: 'REJECTED',
    planogram_approver_time: '2025-01-12 14:30:00',
    planogram_approver_account: 'planogram_manager',
    planogram_approver_name: 'Wang Fang',
  },
  {
    id: 'sg-003',
    code: 'SG003',
    name: 'South China Store Group',
    shopCodes: ['ST010', 'ST011', 'ST012'],
    displayGroupCode: 'DG003',
    displayGroupName: 'Drink Display Group',
    creatorName: 'admin',
    gmtCreate: 1686716400000,
    typicalStoreCode: 'ST010',
    status: 'ENABLE',
    lastExportTime: 1687069800000,
    lastImportTime: undefined,
    remark: 'Store group for South China region, covering stores in Guangdong, Guangxi, Hainan and other areas',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-13 10:15:00',
    commercial_approver_account: 'commercial_manager',
    commercial_approver_name: 'Chen Jun',
    planogram_approver_status: 'PENDING',
    planogram_approver_time: undefined,
    planogram_approver_account: undefined,
    planogram_approver_name: undefined,
  },
  {
    id: 'sg-004',
    code: 'SG004',
    name: 'Southwest Store Group',
    shopCodes: ['ST013', 'ST014', 'ST015', 'ST016'],
    displayGroupCode: 'DG004',
    displayGroupName: 'Daily Goods Display Group',
    creatorName: 'admin',
    gmtCreate: 1686889200000,
    typicalStoreCode: 'ST013',
    status: 'DISABLE',
    lastExportTime: undefined,
    lastImportTime: undefined,
    remark: 'Store group for Southwest region, covering stores in Sichuan, Chongqing, Yunnan and other areas',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-09 15:40:00',
    commercial_approver_account: 'commercial_supervisor',
    commercial_approver_name: 'Liu Gang',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-10 11:25:00',
    planogram_approver_account: 'planogram_supervisor',
    planogram_approver_name: 'Zhao Lei',
  },
  {
    id: 'sg-005',
    code: 'SG005',
    name: 'Northeast Store Group',
    shopCodes: ['ST017', 'ST018', 'ST019'],
    displayGroupCode: 'DG001',
    displayGroupName: 'Beverage Display Group',
    creatorName: 'admin',
    gmtCreate: 1687061400000,
    typicalStoreCode: 'ST017',
    status: 'ENABLE',
    lastExportTime: 1687242300000,
    lastImportTime: 1687252500000,
    remark: 'Store group for Northeast region, covering stores in Heilongjiang, Jilin, Liaoning and other areas',
    commercial_approver_status: 'PENDING',
    commercial_approver_time: undefined,
    commercial_approver_account: undefined,
    commercial_approver_name: undefined,
    planogram_approver_status: 'PENDING',
    planogram_approver_time: undefined,
    planogram_approver_account: undefined,
    planogram_approver_name: undefined,
  },
  {
    id: 'sg-006',
    code: 'SG006',
    name: 'Central China Store Group',
    shopCodes: ['ST020', 'ST021', 'ST022', 'ST023', 'ST024'],
    displayGroupCode: 'DG002',
    displayGroupName: 'Snack Display Group',
    creatorName: 'admin',
    gmtCreate: 1687233000000,
    typicalStoreCode: 'ST020',
    status: 'ENABLE',
    lastExportTime: 1687404000000,
    lastImportTime: 1687414800000,
    remark: 'Store group for Central China region, covering stores in Hubei, Hunan, Henan and other areas',
    commercial_approver_status: 'REJECTED',
    commercial_approver_time: '2025-01-06 13:15:00',
    commercial_approver_account: 'commercial_director',
    commercial_approver_name: 'Zhang Wei',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-07 16:50:00',
    planogram_approver_account: 'planogram_director',
    planogram_approver_name: 'Li Ming',
  },
  {
    id: 'sg-007',
    code: 'SG007',
    name: 'Northwest Store Group',
    shopCodes: ['ST025', 'ST026', 'ST027'],
    displayGroupCode: 'DG003',
    displayGroupName: 'Drink Display Group',
    creatorName: 'admin',
    gmtCreate: 1687405800000,
    typicalStoreCode: 'ST025',
    status: 'ENABLE',
    lastExportTime: 1687577100000,
    lastImportTime: 1687587000000,
    remark: 'Store group for Northwest region, covering stores in Shaanxi, Gansu, Qinghai and other areas',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-11 09:30:00',
    commercial_approver_account: 'commercial_supervisor',
    commercial_approver_name: 'Wang Fang',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-12 14:45:00',
    planogram_approver_account: 'planogram_supervisor',
    planogram_approver_name: 'Chen Jun',
  },
  {
    id: 'sg-008',
    code: 'SG008',
    name: 'Premium Store Group',
    shopCodes: ['ST028', 'ST029', 'ST030', 'ST031'],
    displayGroupCode: 'DG001',
    displayGroupName: 'Beverage Display Group',
    creatorName: 'admin',
    gmtCreate: 1687578300000,
    typicalStoreCode: 'ST028',
    status: 'ENABLE',
    lastExportTime: 1687750200000,
    lastImportTime: 1687760100000,
    remark: 'Premium store group for high-end stores across different regions',
    commercial_approver_status: 'APPROVED',
    commercial_approver_time: '2025-01-13 10:20:00',
    commercial_approver_account: 'commercial_director',
    commercial_approver_name: 'Liu Gang',
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-14 15:40:00',
    planogram_approver_account: 'planogram_director',
    planogram_approver_name: 'Zhao Lei',
  },
  {
    id: 'sg-009',
    code: 'SG009',
    name: 'Empty Test Store Group',
    shopCodes: [],
    displayGroupCode: 'DG005',
    displayGroupName: 'Test Display Group',
    creatorName: 'admin',
    gmtCreate: 1687660100000,
    typicalStoreCode: undefined,
    status: 'DISABLE',
    lastExportTime: undefined,
    lastImportTime: undefined,
    remark: 'Test store group with no stores for testing empty state',
    commercial_approver_status: 'PENDING',
    commercial_approver_time: undefined,
    commercial_approver_account: undefined,
    commercial_approver_name: undefined,
    planogram_approver_status: 'PENDING',
    planogram_approver_time: undefined,
    planogram_approver_account: undefined,
    planogram_approver_name: undefined,
  },
  {
    id: 'sg-010',
    code: 'SG010',
    name: 'Single Store Test Group',
    shopCodes: ['ST032'],
    displayGroupCode: 'DG006',
    displayGroupName: 'Single Store Display Group',
    creatorName: 'admin',
    gmtCreate: 1687742500000,
    typicalStoreCode: 'ST032',
    status: 'ENABLE',
    lastExportTime: 1687828800000,
    lastImportTime: undefined,
    remark: 'Test store group with only one store',
    commercial_approver_status: 'PENDING',
    commercial_approver_time: undefined,
    commercial_approver_account: undefined,
    commercial_approver_name: undefined,
    planogram_approver_status: 'APPROVED',
    planogram_approver_time: '2025-01-16 12:30:00',
    planogram_approver_account: 'planogram_manager',
    planogram_approver_name: 'Li Ming',
  }
];

// 扩展门店数据，添加更多门店以匹配门店组的shopCodes
export const mockStores: Store[] = [
  // East China Store Group (SG001) - store-001 to store-005
  {
    id: 'store-001',
    code: 'ST001',
    name: 'Shanghai Nanjing Road Store',
    detailAddress: '123 Nanjing Road, Shanghai',
    area: 'East China',
    city: 'Shanghai',
    format: 'Flagship',
    clusterSection: 'Large',
    size: 1200,
    isRepresentative: true,
    contact: 'John Smith',
    phone: '021-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-002',
    code: 'ST002',
    name: 'Shanghai Xujiahui Store',
    detailAddress: '456 Xujiahui Road, Shanghai',
    area: 'East China',
    city: 'Shanghai',
    format: 'Standard',
    clusterSection: 'Medium',
    size: 800,
    isRepresentative: false,
    contact: 'Mary Johnson',
    phone: '021-87654321',
    status: 'ENABLE'
  },
  {
    id: 'store-003',
    code: 'ST003',
    name: 'Nanjing Xinjiekou Store',
    detailAddress: '789 Xinjiekou Street, Nanjing',
    area: 'East China',
    city: 'Nanjing',
    format: 'Standard',
    clusterSection: 'Medium',
    size: 900,
    isRepresentative: false,
    contact: 'David Wang',
    phone: '025-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-004',
    code: 'ST004',
    name: 'Hangzhou West Lake Store',
    detailAddress: '321 West Lake Road, Hangzhou',
    area: 'East China',
    city: 'Hangzhou',
    format: 'Standard',
    clusterSection: 'Small',
    size: 850,
    isRepresentative: false,
    contact: 'Lisa Chen',
    phone: '0571-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-005',
    code: 'ST005',
    name: 'Suzhou Guanqian Store',
    detailAddress: '654 Guanqian Street, Suzhou',
    area: 'East China',
    city: 'Suzhou',
    format: 'Standard',
    clusterSection: 'Small',
    size: 750,
    isRepresentative: false,
    contact: 'Mike Zhang',
    phone: '0512-12345678',
    status: 'ENABLE'
  },
  // North China Store Group (SG002) - store-006 to store-009
  {
    id: 'store-006',
    code: 'ST006',
    name: 'Beijing Wangfujing Store',
    detailAddress: '123 Wangfujing Street, Beijing',
    area: 'North China',
    city: 'Beijing',
    format: 'Flagship',
    clusterSection: 'Large',
    size: 1100,
    isRepresentative: true,
    contact: 'Sarah Li',
    phone: '010-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-007',
    code: 'ST007',
    name: 'Beijing Sanlitun Store',
    detailAddress: '456 Sanlitun Road, Beijing',
    area: 'North China',
    city: 'Beijing',
    format: 'Standard',
    clusterSection: 'Small',
    size: 850,
    isRepresentative: false,
    contact: 'Tom Wilson',
    phone: '010-87654321',
    status: 'ENABLE'
  },
  {
    id: 'store-008',
    code: 'ST008',
    name: 'Tianjin Binjiang Store',
    detailAddress: '789 Binjiang Road, Tianjin',
    area: 'North China',
    city: 'Tianjin',
    format: 'Standard',
    clusterSection: 'Small',
    size: 800,
    isRepresentative: false,
    contact: 'Emma Brown',
    phone: '022-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-009',
    code: 'ST009',
    name: 'Shijiazhuang Zhongshan Store',
    detailAddress: '321 Zhongshan Road, Shijiazhuang',
    area: 'North China',
    city: 'Shijiazhuang',
    format: 'Standard',
    clusterSection: 'Small',
    size: 750,
    isRepresentative: false,
    contact: 'Alex Davis',
    phone: '0311-12345678',
    status: 'ENABLE'
  },
  // South China Store Group (SG003) - store-010 to store-012
  {
    id: 'store-010',
    code: 'ST010',
    name: 'Guangzhou Tianhe Store',
    detailAddress: '123 Tianhe Road, Guangzhou',
    area: 'South China',
    city: 'Guangzhou',
    format: 'Flagship',
    clusterSection: 'Large',
    size: 1300,
    isRepresentative: true,
    contact: 'Sophie Chen',
    phone: '020-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-011',
    code: 'ST011',
    name: 'Shenzhen Futian Store',
    detailAddress: '456 Futian Road, Shenzhen',
    area: 'South China',
    city: 'Shenzhen',
    format: 'Standard',
    clusterSection: 'Medium',
    size: 900,
    isRepresentative: false,
    contact: 'Kevin Liu',
    phone: '0755-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-012',
    code: 'ST012',
    name: 'Zhuhai Xiangzhou Store',
    detailAddress: '789 Xiangzhou Road, Zhuhai',
    area: 'South China',
    city: 'Zhuhai',
    format: 'Standard',
    clusterSection: 'Small',
    size: 700,
    isRepresentative: false,
    contact: 'Grace Wang',
    phone: '0756-12345678',
    status: 'ENABLE'
  },
  // Southwest Store Group (SG004) - store-013 to store-016
  {
    id: 'store-013',
    code: 'ST013',
    name: 'Chengdu Chunxi Store',
    detailAddress: '123 Chunxi Road, Chengdu',
    area: 'Southwest',
    city: 'Chengdu',
    format: 'Flagship',
    clusterSection: 'Medium',
    size: 1000,
    isRepresentative: true,
    contact: 'Jack Liu',
    phone: '028-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-014',
    code: 'ST014',
    name: 'Chongqing Jiefangbei Store',
    detailAddress: '456 Jiefangbei Street, Chongqing',
    area: 'Southwest',
    city: 'Chongqing',
    format: 'Standard',
    clusterSection: 'Small',
    size: 850,
    isRepresentative: false,
    contact: 'Amy Zhou',
    phone: '023-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-015',
    code: 'ST015',
    name: 'Kunming Nanping Store',
    detailAddress: '789 Nanping Street, Kunming',
    area: 'Southwest',
    city: 'Kunming',
    format: 'Standard',
    clusterSection: 'Small',
    size: 750,
    isRepresentative: false,
    contact: 'Peter Yang',
    phone: '0871-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-016',
    code: 'ST016',
    name: 'Guiyang Zhonghua Store',
    detailAddress: '321 Zhonghua Road, Guiyang',
    area: 'Southwest',
    city: 'Guiyang',
    format: 'Standard',
    clusterSection: 'Small',
    size: 700,
    isRepresentative: false,
    contact: 'Linda Wu',
    phone: '0851-12345678',
    status: 'ENABLE'
  },
  // Northeast Store Group (SG005) - store-017 to store-019
  {
    id: 'store-017',
    code: 'ST017',
    name: 'Harbin Zhongyang Store',
    detailAddress: '123 Zhongyang Street, Harbin',
    area: 'Northeast',
    city: 'Harbin',
    format: 'Flagship',
    clusterSection: 'Medium',
    size: 950,
    isRepresentative: true,
    contact: 'Robert Zhang',
    phone: '0451-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-018',
    code: 'ST018',
    name: 'Changchun Renmin Store',
    detailAddress: '456 Renmin Street, Changchun',
    area: 'Northeast',
    city: 'Changchun',
    format: 'Standard',
    clusterSection: 'Small',
    size: 800,
    isRepresentative: false,
    contact: 'Helen Li',
    phone: '0431-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-019',
    code: 'ST019',
    name: 'Shenyang Taiyuan Store',
    detailAddress: '789 Taiyuan Street, Shenyang',
    area: 'Northeast',
    city: 'Shenyang',
    format: 'Standard',
    clusterSection: 'Small',
    size: 850,
    isRepresentative: false,
    contact: 'Frank Wang',
    phone: '024-12345678',
    status: 'ENABLE'
  },
  // Central China Store Group (SG006) - store-020 to store-024
  {
    id: 'store-020',
    code: 'ST020',
    name: 'Wuhan Jianghan Store',
    detailAddress: '123 Jianghan Road, Wuhan',
    area: 'Central China',
    city: 'Wuhan',
    format: 'Flagship',
    clusterSection: 'Large',
    size: 1100,
    isRepresentative: true,
    contact: 'Nancy Chen',
    phone: '027-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-021',
    code: 'ST021',
    name: 'Changsha Wuyi Store',
    detailAddress: '456 Wuyi Road, Changsha',
    area: 'Central China',
    city: 'Changsha',
    format: 'Standard',
    clusterSection: 'Medium',
    size: 900,
    isRepresentative: false,
    contact: 'Steven Liu',
    phone: '0731-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-022',
    code: 'ST022',
    name: 'Zhengzhou Erqi Store',
    detailAddress: '789 Erqi Road, Zhengzhou',
    area: 'Central China',
    city: 'Zhengzhou',
    format: 'Standard',
    clusterSection: 'Small',
    size: 850,
    isRepresentative: false,
    contact: 'Monica Wang',
    phone: '0371-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-023',
    code: 'ST023',
    name: 'Nanchang Bayi Store',
    detailAddress: '321 Bayi Road, Nanchang',
    area: 'Central China',
    city: 'Nanchang',
    format: 'Standard',
    clusterSection: 'Small',
    size: 750,
    isRepresentative: false,
    contact: 'Eric Zhou',
    phone: '0791-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-024',
    code: 'ST024',
    name: 'Hefei Changjiang Store',
    detailAddress: '654 Changjiang Road, Hefei',
    area: 'Central China',
    city: 'Hefei',
    format: 'Standard',
    clusterSection: 'Small',
    size: 800,
    isRepresentative: false,
    contact: 'Jessica Li',
    phone: '0551-12345678',
    status: 'ENABLE'
  },
  // Northwest Store Group (SG007) - store-025 to store-027
  {
    id: 'store-025',
    code: 'ST025',
    name: 'Xian Xiaozhai Store',
    detailAddress: '123 Xiaozhai Road, Xian',
    area: 'Northwest',
    city: 'Xian',
    format: 'Flagship',
    clusterSection: 'Medium',
    size: 1000,
    isRepresentative: true,
    contact: 'Daniel Zhang',
    phone: '029-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-026',
    code: 'ST026',
    name: 'Lanzhou Zhongshan Store',
    detailAddress: '456 Zhongshan Road, Lanzhou',
    area: 'Northwest',
    city: 'Lanzhou',
    format: 'Standard',
    clusterSection: 'Small',
    size: 750,
    isRepresentative: false,
    contact: 'Carol Wu',
    phone: '0931-12345678',
    status: 'ENABLE'
  },
  {
    id: 'store-027',
    code: 'ST027',
    name: 'Xining Dashizi Store',
    detailAddress: '789 Dashizi Street, Xining',
    area: 'Northwest',
    city: 'Xining',
    format: 'Standard',
    clusterSection: 'Small',
    size: 700,
    isRepresentative: false,
    contact: 'Tony Liu',
    phone: '0971-12345678',
    status: 'ENABLE'
  },
  // Premium Store Group (SG008) - store-028 to store-031
  {
    id: 'store-028',
    code: 'ST028',
    name: 'Shanghai IFC Premium Store',
    detailAddress: '8 Century Avenue, Shanghai IFC Mall',
    area: 'East China',
    city: 'Shanghai',
    format: 'Premium',
    clusterSection: 'Large',
    size: 1500,
    isRepresentative: true,
    contact: 'Victoria Chen',
    phone: '021-88888888',
    status: 'ENABLE'
  },
  {
    id: 'store-029',
    code: 'ST029',
    name: 'Beijing SKP Premium Store',
    detailAddress: '87 Jianguo Road, Beijing SKP',
    area: 'North China',
    city: 'Beijing',
    format: 'Premium',
    clusterSection: 'Large',
    size: 1400,
    isRepresentative: false,
    contact: 'William Wang',
    phone: '010-88888888',
    status: 'ENABLE'
  },
  {
    id: 'store-030',
    code: 'ST030',
    name: 'Shenzhen MixC Premium Store',
    detailAddress: '1881 Bao\'an South Road, Shenzhen MixC',
    area: 'South China',
    city: 'Shenzhen',
    format: 'Premium',
    clusterSection: 'Large',
    size: 1300,
    isRepresentative: false,
    contact: 'Sophia Liu',
    phone: '0755-88888888',
    status: 'ENABLE'
  },
  {
    id: 'store-031',
    code: 'ST031',
    name: 'Guangzhou Taikoo Hui Premium Store',
    detailAddress: '383 Tianhe Road, Guangzhou Taikoo Hui',
    area: 'South China',
    city: 'Guangzhou',
    format: 'Premium',
    clusterSection: 'Large',
    size: 1350,
    isRepresentative: false,
    contact: 'Andrew Zhang',
    phone: '020-88888888',
    status: 'ENABLE'
  },
  // Single Store Test Group (SG010) - store ST032
  {
    id: 'store-032',
    code: 'ST032',
    name: 'Test Single Store',
    detailAddress: '999 Test Street, Test City',
    area: 'Test Region',
    city: 'Test City',
    format: 'Standard',
    clusterSection: 'Small',
    size: 600,
    isRepresentative: true,
    contact: 'Test Manager',
    phone: '000-00000000',
    status: 'ENABLE'
  }
];



// 模拟门店组状态选项
export const STORE_GROUP_STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'ENABLE', label: '激活' },
  { value: 'DISABLE', label: '停用' },
];

// 状态颜色
export const STORE_GROUP_STATUS_COLORS = {
  ENABLE: '#52c41a',
  DISABLE: '#ff4d4f',
};

// 状态标签
export const STORE_GROUP_STATUS_LABELS = {
  ENABLE: '激活',
  DISABLE: '停用',
};